<template>
    <section id="error_main" class="section_padding">
        <div class="container mt-5">
            <div class="row mt-5">
                <div class="col-lg-6 offset-lg-3 col-md-12 col-sm-12 col-12">
                    <div class="error_content text-center mt-5">
                        <img src="../../assets/img/common/success.png" alt="img">
                        <h2>{{ $t('Your flight reservation is complete') }}</h2>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>
<script>

export default {
    name: "ErrorArea",
    methods: {
        BackHome() {
            this.$router.go(-1)
        }
    }
};
</script>